import { Search } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useSearch } from "../SearchProvider";

export function SearchMobileButton() {
  const { t } = useTranslation();
  const { open, inputRef } = useSearch();

  return (
    <button
      type="button"
      onClick={() => {
        open();
        inputRef.current?.focus();
      }}
      aria-label={t.header.search}
      className="rhythm-icon-btn shrink-0 lg:hidden"
    >
      <Search size={20} strokeWidth={1.75} />
    </button>
  );
}
